import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="period-toggle"
export default class extends Controller {
  static targets = ["button"]
  static values = { current: String }

  connect() {
    // Controller connected - period toggle is handled via Turbo links
  }
}
